import axios from "axios";

export const callGetAPI = async (url, data = {}) => {
  let params = "";
  Object.keys(data).forEach((key) => {
    if (data[key] && data[key] !== "ALL") {
      if (!params) {
        params += "?";
      } else {
        params += "&";
      }
      params += key + "=" + data[key];
    }
  });
  const result = await axios.get(process.env.REACT_APP_API_URL + url + params);

  return result.data;
};
